import useTranslation from 'next-translate/useTranslation';
import React from 'react';

export function OfficeContact() {
  const { t } = useTranslation();
  return (
    <h3 className='text-lg'>
      <ul>
        <li>BEVMAQ GmbH</li>
        <li>Mühlenhorst 8 </li>
        <li>49637 Menslage </li>
        <li>{t('common:Phone')}: +49 173 90 80 414</li>
        <li>
          {t('common:email')}:
          <a href='mailto:contact@bevmaq.com' className='text-blue-500'>
            <span> contact@bevmaq.com</span>
          </a>
        </li>
      </ul>
    </h3>
  );
}
